import type { AuthToken, AuthUser } from '@aibees/shared/definition';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePostHog } from '@aibees/shared/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { useEffect, useRef } from 'react';

export const useIdentifyPostHogUserInfo = (
  user?: AuthUser | null,
  token?: AuthToken | null
) => {
  const { identify: identifyPostHog } = usePostHog();
  const workspace = useWorkspace();
  const subscriptionData = useCurrentSubscriptionApi();
  const prevPlanRef = useRef<string | undefined>();

  useEffect(() => {
    if (
      !user ||
      !user.id ||
      !token ||
      !workspace?.id ||
      !subscriptionData?.data ||
      subscriptionData?.isLoading
    )
      return;

    const subscription = subscriptionData.data;
    const isFree = subscription?.current?.plan?.metadata?.is_free === 'true';
    const planType = isFree ? 'Free plan' : 'Usage Based-Plan';
    const planName = subscription?.current?.plan?.product?.name;
    const subscriptionStatus = subscription?.current?.status;

    if (prevPlanRef.current !== planType) {
      identifyPostHog(user.id, {
        name: user.firstName + ' ' + user.lastName,
        email: user.email,
        phone: user.attributes?.phone || null,
        company: user.attributes?.company || null,
        title: user.attributes?.title,
        site: user.attributes?.site,
        industry: user.attributes?.industry,
        alternateEmail: user.attributes?.alternateEmail,
        avatar: user.attributes?.avatar,
        lastLogin: new Date().toISOString(),
        customerId: user.id,
        username: user.username,
        roles: user.roles,
        realmAccessRoles: user.realmAccessRoles,
        subscriptionPlan: planType,
        planName: planName || null,
        subscriptionStatus: subscriptionStatus || null,
      });
      prevPlanRef.current = planType;
    }
  }, [
    user,
    token,
    workspace?.id,
    subscriptionData?.data,
    subscriptionData?.isLoading,
    identifyPostHog,
  ]);
};
